module.exports = __webpack_public_path__ + "img/icon-num1.998ef7a3.png";